module.exports = __webpack_public_path__ + "static/media/21.f1ea72ee.svg";